import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withStyles } from '@material-ui/core/styles'
import withWidth from '@material-ui/core/withWidth'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Divider from '@material-ui/core/Divider'
import { hideModal, unmountModal } from 'redux/modules/modals'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
function Transition(props) {
  return <Slide direction="up" {...props} />
}
function widthWrapper(width) {
  return width === 'lg' || width === 'xl' ? 'md' : width
}
const styles = theme => ({
  appBar: {
    position: 'relative'
  },
  title: {
    flex: 1
  },
  validationButton: {
    margin: theme.spacing.unit
  },
  dialogContent: {
    padding: '24px'
  },
  dialogDeleteTitle: {
    color: theme.palette.secondary.main
  }
})
const checkWarningModal = title => {
  return (
    title.includes('Attention') ||
    title.includes('Supprimer') ||
    title.includes('Erreur')
  )
}
const ModalWrapper = props => {
  const onOk = () => {
    if (props.onOk) {
      props.onOk()
    }
    props.hideModal()
  }
  const onCancel = () => {
    if (props.onCancel) {
      props.onCancel()
    }
    props.hideModal()
  }
  const okButton = props.showOk ? (
    <Button
      className={props.classes.validationButton}
      disabled={props.okDisabled}
      onClick={onOk}
      color="primary">
      {props.okText}
    </Button>
  ) : null
  const cancelButton = props.showCancel ? (
    <Button
      className={props.classes.validationButton}
      onClick={onCancel}
      color={props.showOk ? 'secondary' : 'primary'}>
      {props.cancelText}
    </Button>
  ) : null
  const renderAppBarTitle = (classes, title, showCancel) => {
    return (
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant="title" color="inherit" className={classes.title}>
            {title}
          </Typography>
          {showCancel ? (
            <IconButton color="inherit" onClick={onCancel} aria-label="Close">
              <CloseIcon color="inherit" />
            </IconButton>
          ) : null}
        </Toolbar>
      </AppBar>
    )
  }
  return (
    <Dialog
      open={props.open}
      onExited={props.unmountModal}
      onClose={onCancel}
      fullWidth
      disableBackdropClick={!props.showCancel}
      disableEscapeKeyDown={!props.showCancel}
      maxWidth={widthWrapper(props.width)}
      TransitionComponent={Transition}>
      {props.appBar ? (
        renderAppBarTitle(props.classes, props.title, props.showCancel)
      ) : (
        <DialogTitle disableTypography>
          <Typography
            variant="title"
            color={checkWarningModal(props.title) ? 'secondary' : 'inherit'}>
            {props.title}
          </Typography>
        </DialogTitle>
      )}
      <Divider light />
      <DialogContent classes={{ root: props.classes.dialogContent }}>
        {props.children}
      </DialogContent>
      {(cancelButton || okButton) && <Divider light />}
      <DialogActions>
        {cancelButton}
        {okButton}
      </DialogActions>
    </Dialog>
  )
}
ModalWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  appBar: PropTypes.bool,
  title: PropTypes.string,
  showOk: PropTypes.bool,
  showCancel: PropTypes.bool,
  okText: PropTypes.string,
  okDisabled: PropTypes.bool,
  cancelText: PropTypes.string,
  width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string
  ]).isRequired,
  // methods
  unmountModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  onOk: PropTypes.func,
  onCancel: PropTypes.func
}
ModalWrapper.defaultProps = {
  open: true,
  appBar: false,
  title: '',
  width: 'xs',
  showCancel: true,
  showOk: true,
  cancelText: 'Annuler',
  okText: 'Valider',
  okDisabled: false,
  onOk: () => {}
}
const mapActionCreators = {
  hideModal,
  unmountModal
}
const mapStateToProps = state => {
  return {
    open: state.modals.open
  }
}
export default connect(mapStateToProps, mapActionCreators)(
  compose(withStyles(styles), withWidth())(ModalWrapper)
)



// WEBPACK FOOTER //
// ./src/components/modals/ModalWrapper.js